import React from 'react';
import ReactTooltip from 'react-tooltip';

import { StyledToolTip } from './ToolTip.styles';

import { ToolTipProps } from './ToolTip.types';

const ToolTip = ({
  id,
  content,
  anchorContentSlot,
  place = 'right',
  effect = 'solid',
  componentClassname = 'tooltip',
  customClassnames = '',
  customStyle = '',
}: ToolTipProps) => {
  return (
    <StyledToolTip
      className={`${componentClassname}__wrapper ${componentClassname}__wrapper--is-${place} ${customClassnames}`}
      customStyle={customStyle}
    >
      <div
        data-tip={true}
        data-for={id}
        className={`${componentClassname}__anchor`}
      >
        <div className={`${componentClassname}__anchor-content`}>
          {anchorContentSlot}
        </div>
      </div>
      <ReactTooltip
        className={`${componentClassname}`}
        id={id}
        place={place}
        effect={effect}
      >
        <div className={`${componentClassname}__content`}>{content}</div>
      </ReactTooltip>
    </StyledToolTip>
  );
};
ToolTip.displayName = 'ToolTip';

export default ToolTip;
